import script from "./DelivMng.vue?vue&type=script&setup=true&name=DelivMng&lang=js"
export * from "./DelivMng.vue?vue&type=script&setup=true&name=DelivMng&lang=js"

const __exports__ = script;

export default __exports__